import {
  CircularProgress,
  makeStyles,
  Popover,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const useStyles = makeStyles((theme) => ({
  content: {
    height: "300px",
    maxWidth: "600px",
    width: "100%",
    marginBottom: "0px",
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      height: "400px",
      width: "80%",
      marginBottom: "40px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "300px",
      width: "90%",
      margin: "0 auto",
      marginBottom: "30px",
    },
  },
  videoWrapper: {
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
    borderRadius: "4px",
  },
  frame: {
    position: "relative",
    height: "300px",
    maxWidth: "800px",
    border: "none",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "400px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "300px",
    },
  },
  vidDesc: {
    marginLeft: "30px",
    color: "#151b26",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
    "&:hover": {
      textDecoration: "underline",
    },
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    marginTop: "3px",
    backgroundColor: "transparent",
    boxShadow: "none",
    color: "#4e4d5e",
    marginLeft: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function VidHoriz(props) {
  const [isLoading, setIsLoading] = useState(true);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const classes = useStyles();
  return (
    <>
      <Typography variant="h6">
        <a
          className={classes.vidDesc}
          href={`https://youtube.com/playlist?list=${props.videoLink}`}
          target="_blank"
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          {props.description}
        </a>
      </Typography>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography style={{ fontSize: "0.75em" }}>
          <ArrowForwardIcon style={{ fontSize: ".8em", marginRight: "10px" }} />
          Open playlist on youtube
        </Typography>
      </Popover>
      <div className={classes.content}>
        <div className={classes.videoWrapper}>
          {isLoading ? (
            <CircularProgress
              size={100}
              style={{
                position: "absolute",
              }}
            />
          ) : null}
          <iframe
            className={classes.frame}
            src={`https://www.youtube.com/embed/videoseries?list=${props.videoLink}`}
            title="YouTube video player"
            allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            onLoad={() => setIsLoading(false)}
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default VidHoriz;
